/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Klaviyo form trigger buttons
  document.addEventListener('DOMContentLoaded', function() {
    var klaviyoButtons = document.querySelectorAll('.klaviyo-form-trigger');

    console.log('buttons', klaviyoButtons);
    
    klaviyoButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var formId = this.getAttribute('data-klaviyo-form-id');
        if (formId) {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', formId]);
        }
      });
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}